// Радиус земли
const earthRadius = 6372795

const locationService = {
    getDistance(lat1, lng1, lat2, lng2) {
        const xLat1 = parseFloat(lat1) * Math.PI / 180
        const yLng1 = parseFloat(lng1) * Math.PI / 180
        const xLat2 = parseFloat(lat2) * Math.PI / 180
        const yLng2 = parseFloat(lng2) * Math.PI / 180

        if (xLat1 && yLng1 && xLat2 && yLng2) {
            // косинусы и синусы широт и разницы долгот
            const cl1 = Math.cos(xLat1)
            const cl2 = Math.cos(xLat2)
            const sl1 = Math.sin(xLat1)
            const sl2 = Math.sin(xLat2)
            const delta = yLng2 - yLng1
            const cDelta = Math.cos(delta)
            const sDelta = Math.sin(delta)

            // вычисления длины большого круга
            const y = Math.sqrt(Math.pow(cl2 * sDelta, 2) + Math.pow(cl1 * sl2 - sl1 * cl2 * cDelta, 2))
            const x = sl1 * sl2 + cl1 * cl2 * cDelta

            const ad = Math.atan2(y, x)

            return ad * earthRadius
        }

        return 0
    },

    getDistanceFormatted(lat1, lng1, lat2, lng2) {
        let distance = locationService.getDistance(lat1, lng1, lat2, lng2)

        distance = distance / 1000

        if (distance > 10) {
            return Math.floor(distance)
        } else {
            return distance.toFixed(1)
        }
    },
}

export default locationService
